const awsmobile = {
  aws_project_region: "ap-south-1",
  aws_cognito_identity_pool_id:
    "ap-south-1:34c7c83b-f215-4493-b0c7-825c0f23e44e",
  aws_cognito_region: "ap-south-1",
  aws_user_pools_id: "ap-south-1_QWKatymF1",
  aws_user_pools_web_client_id: "71fbv4qhg4q3c78aec82jv2q5",
  oauth: {},
  aws_cognito_username_attributes: [],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: ["EMAIL"],
  aws_cognito_mfa_configuration: "OFF",
  aws_cognito_mfa_types: ["SMS"],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [],
  },
  aws_cognito_verification_mechanisms: ["EMAIL"],
};

export default awsmobile;

// export const awsmobile = {
//     aws_project_region: 'ap-south-1', // Example: Your AWS region
//     aws_cognito_region: 'ap-south-1', // Example: Your Cognito region
//     aws_user_pools_id: 'ap-south-1_o1ay2bqX4',
//     aws_user_pools_web_client_id: '6tt9hu94p7h9vb58jkknnst1p7',
//     oauth: {},
// };

// export default awsmobile;
